import { Box, Grid, Typography } from '@mui/material'

import { Fragment, useCallback } from 'react'

import { useAppSnackbar } from '@services/hooks/AppSnackbar'

import Tile from '@components/Tile'
import { AWS, AZURE } from '@features/hooks/LandingZones';

function AWSDetails({ data }) {
    const { show } = useAppSnackbar();

    const handleAddToClipboard = useCallback(() => {
        if (!data.json) return
        navigator.clipboard.writeText(JSON.stringify(data.json))
        show("Copied to clipboard", "success", 2000)
    }, [data.json, show])

    if (!data.json) {
        return (
            <Grid item xs={12} textAlign={'left'}>
                <Typography variant={'body2'} color={'text.secondary'}>
                    No JSON data available
                </Typography>
            </Grid>
        )
    }

    return (
        <Grid item xs={12} textAlign={'left'}>
            <Tile onClick={handleAddToClipboard}>
                <Box
                    component={'pre'}
                    sx={{
                        overflowX: 'hidden',
                        height: 'auto'
                    }}
                >
                    {JSON.stringify(data.json, null, 2)}
                </Box>
            </Tile>
        </Grid>
    )
}

function AzureDetails({ data }) {
    const renderField = (label, value) => (
        <Fragment key={label}>
            <Grid item xs={6} sm={2} textAlign={'left'}>
                <Typography component={"dt"} variant={'h6'} >{label}</Typography>
            </Grid>
            <Grid item xs={6} sm={10} textAlign={'left'}>
                <Typography component={"dd"} variant={'body2'} sx={{ margin: 0 }}>
                    {value && value.length > 0 ? value : '-'}
                </Typography>
            </Grid>
        </Fragment>
    )

    return (
        <Grid item xs={12}>
            <Tile>
                <Grid component={'dl'} container spacing={1}>
                    {renderField('Policy', data.policy)}
                    {renderField('Rule collection group', data.ruleCollectionGroup)}
                    {renderField('Rule collection', data.ruleCollection)}
                    {renderField('Rule', data.rule)}
                </Grid>
            </Tile>
        </Grid>
    )
}

function Details({ data }) {
    const renderDetails = () => {
        switch (data.provider) {
            case AWS:
                return <AWSDetails data={data} />
            case AZURE:
                return <AzureDetails data={data} />
            default:
                return (
                    <Grid item xs={12}>
                        <Typography variant={'body2'} color={'error'}>
                            Unsupported provider: {data.provider}
                        </Typography>
                    </Grid>
                )
        }
    }

    return (
        <Box p={2} >
            <Grid container spacing={3} textAlign={'left'}>
                {renderDetails()}
            </Grid>
        </Box>
    )
}

Details.displayName = 'RowDetails'

export default Details